import { BACKEND_API_BASE_URL } from '../config';

class CategoriesAPI {
  async getAllCategories(authToken = null, schoolId = null, adminView = false) {
    const headers = {};
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    let url = `${BACKEND_API_BASE_URL}/api/categories`;
    const params = new URLSearchParams();
    
    if (schoolId) {
      params.append('school_id', schoolId);
    }
    
    if (adminView) {
      params.append('admin_view', 'true');
    }
    
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    console.log('🔍 CategoriesAPI: Requesting URL:', url);
    console.log('🔍 CategoriesAPI: Parameters:', { schoolId, adminView });
    
    const response = await fetch(url, { headers });
    if (!response.ok) {
      throw new Error('Failed to fetch categories');
    }
    const data = await response.json();
    
    console.log('🔍 CategoriesAPI: Response data:', data);
    return data;
  }

  async createCategory(categoryData, authToken = null) {
    const headers = {
      'Content-Type': 'application/json',
    };
    
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(`${BACKEND_API_BASE_URL}/api/categories`, {
      method: 'POST',
      headers,
      body: JSON.stringify(categoryData),
    });
    if (!response.ok) {
      throw new Error('Failed to create category');
    }
    return response.json();
  }

  async updateCategory(id, updateData, authToken = null) {
    const headers = {
      'Content-Type': 'application/json',
    };
    
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(`${BACKEND_API_BASE_URL}/api/categories/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(updateData),
    });
    if (!response.ok) {
      throw new Error('Failed to update category');
    }
    return response.json();
  }

  async deleteCategory(id, authToken = null) {
    if (!id) {
      throw new Error('Category ID is required');
    }

    const headers = {};
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    console.log(`Deleting category with ID: ${id}`);
    
    const response = await fetch(`${BACKEND_API_BASE_URL}/api/categories/${id}`, {
      method: 'DELETE',
      headers,
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`Delete category failed with status ${response.status}:`, errorText);
      
      let errorMessage = `Failed to delete category (${response.status})`;
      try {
        const errorData = JSON.parse(errorText);
        errorMessage = errorData.error || errorData.message || errorMessage;
      } catch (e) {
        // If not JSON, use the raw text or status message
        errorMessage = errorText || response.statusText || errorMessage;
      }
      
      throw new Error(errorMessage);
    }
    
    const result = await response.json();
    console.log('Category deleted successfully:', result);
    return result;
  }
}

const categoriesAPI = new CategoriesAPI();
export default categoriesAPI;